import { IMessage, useSubscription } from "react-stomp-hooks";
import { RefreshButton } from "../../shared/RefreshButton";
import { EventBase } from "../../../interfaces/dtos/common";

interface ScheduleCommonRefreshProps {
    eventId: number,
    topic: string,
    desc: string,
    loading: boolean,
    onRefresh: () => void;
}

export const ScheduleCommonRefresh = ({
    eventId, topic, desc, loading, onRefresh
}: ScheduleCommonRefreshProps) => {

    const handleMessage = (message: IMessage) => {
        const newItem: EventBase = JSON.parse(message.body);
        if (eventId && newItem.eventId.toString() !== eventId.toString()) {
            console.log('Received unknown message for refresh (refreshing anyway): ', message.body);
        }
        onRefresh();
    }

    useSubscription(
        `/topic/${topic}/${eventId}`,
        (message) => handleMessage(message)
    );

    return (
        <RefreshButton
            id="btn-refresh"
            tooltip={`Refresh ${desc}`}
            loading={loading}
            onClick={onRefresh}
        />
    )
}
